var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import useWindowSize from "syf-component-library/ui/customHooks/useWindowWidth";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileDownload, faPrint } from "@fortawesome/pro-regular-svg-icons";
import { Border, Header, Icons, Interactivity, LinkToStatements, Navigation, Pointer, StatementDate, } from "./subcomponents";
import { getClickAnalyticsProperties } from "../../../const/analytics";
var RETURN_TO_STATEMENT_LIST_ANALYTICS = getClickAnalyticsProperties({
    reason: "return to statement list",
});
var PDFStatementHeader = function (_a) {
    var cachedBlob = _a.cachedBlob, isLoading = _a.isLoading, isError = _a.isError, onReturnToStatementListClick = _a.onReturnToStatementListClick;
    var t = useTranslation().t;
    var isLessThanTablet = useWindowSize().isLessThanTablet;
    var searchParams = useSearchParams()[0];
    var statementDate = searchParams.get("statementDate");
    var handleDownloadPdf = function () {
        if (cachedBlob) {
            var url = URL.createObjectURL(cachedBlob);
            var a = Object.assign(document.createElement("a"), {
                href: url,
                download: "".concat(statementDate),
            });
            a.click();
            window.URL.revokeObjectURL(url);
        }
    };
    var handlePrintPdf = function () {
        if (cachedBlob) {
            var url = URL.createObjectURL(cachedBlob);
            var printWindow_1 = window.open(url);
            printWindow_1 === null || printWindow_1 === void 0 ? void 0 : printWindow_1.addEventListener("load", function () {
                printWindow_1.focus();
                printWindow_1.print();
            });
        }
    };
    return (_jsxs(Header, { children: [_jsxs(Navigation, __assign({ "$isLessThanTablet": isLessThanTablet }, { children: [_jsxs(StatementDate, __assign({ "$isLessThanTablet": isLessThanTablet }, { children: [t("pdfPage.synchronyBankStatement"), " - ", statementDate] })), !isLessThanTablet && (_jsx(LinkToStatements, __assign({ href: "" }, RETURN_TO_STATEMENT_LIST_ANALYTICS, { onClick: onReturnToStatementListClick, "$isLessThanTablet": isLessThanTablet }, { children: t("pdfPage.returnToStatementList") })))] })), (cachedBlob || isError) && (_jsx(Interactivity, __assign({ "$isLessThanTablet": isLessThanTablet }, { children: _jsxs(_Fragment, { children: [isLessThanTablet && (_jsx(LinkToStatements, __assign({ href: "" }, RETURN_TO_STATEMENT_LIST_ANALYTICS, { onClick: onReturnToStatementListClick, "$isLessThanTablet": isLessThanTablet }, { children: t("pdfPage.returnToStatementList") }))), cachedBlob && !isLoading && (_jsxs(Icons, { children: [_jsx(Border, { children: _jsx(Pointer, { children: _jsx(FontAwesomeIcon, __assign({ icon: faFileDownload, size: "lg", onClick: handleDownloadPdf }, getClickAnalyticsProperties({ reason: "download" }), { title: "download" })) }) }), _jsx(Pointer, { children: _jsx(FontAwesomeIcon, __assign({ icon: faPrint, size: "lg", title: "print", onClick: handlePrintPdf }, getClickAnalyticsProperties({ reason: "print" }))) })] }))] }) })))] }));
};
export default PDFStatementHeader;
